import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CommuterTrafficDistanceService } from './commuter-traffic-distance.service';

const service = new CommuterTrafficDistanceService();

export interface CommuterTrafficDistanceState {}

const CommuterTrafficDistanceStore: Module<CommuterTrafficDistanceState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getCommutterTrafficDistance(context: any, addresses: any) {
         return await service.getCommuterTrafficDistance(addresses.employee_address, addresses.work_address);
      },
   },
};

export default CommuterTrafficDistanceStore;
